import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto } from 'src/app/core/api/models';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { ResellersService } from '../../../../core/api/services/resellers.service';
import { PaginatedListOfResellersWithPaginationByUserIdDto } from './../../../../core/api/models/paginated-list-of-resellers-with-pagination-by-user-id-dto';
import { ResellersWithPaginationByUserIdDto } from './../../../../core/api/models/resellers-with-pagination-by-user-id-dto';

@Component({
  selector: 'app-reseller-organizations',
  templateUrl: './reseller-organizations.component.html',
  imports: [BaseIndexModule],
})
export class ResellerOrganizationsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  pageName = 'resellers';

  @Input()
  modelWithPagination$: Observable<PaginatedListOfResellersWithPaginationByUserIdDto>;
  items$: Observable<Array<ResellersWithPaginationByUserIdDto>>;
  @Input() userId: any;
  @Output('onBack') output_onBack = new EventEmitter<boolean>();

  constructor(protected currentService: ResellersService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.title = 'pages.resellers.resellerOrganizations.' + 'title';
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showHelpBtn = false;
    this.pageConfig.showRefreshBtn = true;
    this.pageConfig.tableConfig.showOperationColumn = false;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.organization,
        name: 'user.organization.name',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}panelPercent`,
        name: 'panelPercent',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}pricePerSms`,
        name: 'pricePerSms',
        hasSearch: true,
        type: 'number',
        needCurrency: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'date',
      },
    ];
  }

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfResellersWithPaginationByUserIdDto> {
    return this.currentService.resellersGetResellersWithPaginationByUserId({
      body: { ...this.getBaseModelWithPaginationParams(), userId: this.userId },
    });
  }

  emitOnBack() {
    this.output_onBack.emit(true);
    this.unSubs();
  }
}
